// app/shared/store/loadingStore.ts

// // app/shared/store/loadingStore.ts

// app/shared/store/loadingStore.ts
import { create } from "zustand";

interface LoadingState {
  // Global loading state
  isLoading: boolean;

  // Named loading states for specific operations
  namedLoadingStates: Record<string, boolean>;

  // Actions
  setIsLoading: (isLoading: boolean) => void;
  setNamedLoadingState: (name: string, isLoading: boolean) => void;

  // Helpers
  isAnyLoading: () => boolean;
  getNamedLoadingState: (name: string) => boolean;
}

export const useLoadingStore = create<LoadingState>((set, get) => ({
  isLoading: false,
  namedLoadingStates: {},

  setIsLoading: (isLoading: boolean) => set({ isLoading }),

  setNamedLoadingState: (name: string, isLoading: boolean) =>
    set((state) => ({
      namedLoadingStates: {
        ...state.namedLoadingStates,
        [name]: isLoading,
      },
    })),

  isAnyLoading: () => {
    const state = get();
    return (
      state.isLoading ||
      Object.values(state.namedLoadingStates).some((value) => value)
    );
  },

  getNamedLoadingState: (name: string) => {
    return get().namedLoadingStates[name] || false;
  },
}));
// "use client";

// import { create } from 'zustand';

// /**
//  * Interface for the loading state store
//  */
// interface LoadingState {
//   /**
//    * Global loading state
//    */
//   isLoading: boolean;

//   /**
//    * Set the global loading state
//    */
//   setIsLoading: (isLoading: boolean) => void;

//   /**
//    * Named loading states for tracking multiple loading operations
//    */
//   loadingStates: Record<string, boolean>;

//   /**
//    * Set a named loading state
//    */
//   setNamedLoadingState: (name: string, isLoading: boolean) => void;

//   /**
//    * Check if any named loading state is active
//    */
//   isAnyLoading: () => boolean;
// }

// /**
//  * Global loading state store using Zustand
//  * This can be used to show loading indicators across the app
//  */
// export const useLoadingStore = create<LoadingState>((set, get) => ({
//   isLoading: false,
//   setIsLoading: (isLoading: boolean) => set({ isLoading }),

//   loadingStates: {},
//   setNamedLoadingState: (name: string, isLoading: boolean) =>
//     set((state) => ({
//       loadingStates: {
//         ...state.loadingStates,
//         [name]: isLoading,
//       },
//     })),

//   isAnyLoading: () => {
//     const state = get();
//     if (state.isLoading) return true;

//     return Object.values(state.loadingStates).some(Boolean);
//   },

//   getNamedLoadingState: (name: string) => {
//     return get().namedLoadingStates[name] || false;
//   }
// }));
